import { IAuthState } from './types';

export const NAME = 'auth';
export const FORGOT_PASSWORD_PATH = '/forgot-password/';
export const RESET_PASSWORD_PATH = '/reset-password/:code/';
export const LOGIN = '/login/';
export const LOGOUT = '/logout/';

export const initialState: IAuthState = {
  token: '',
  expiresAt: '',
  renewToken: '',
  renewTokenExpiresAt: '',

  mfaToken: '',

  rememberMe: false,

  error: null,
};
